import type { DayOfTheWeek, DeliveryTimeDateRangeType, DeliveryTimeType } from 'webapp/enums/enums';
import { equal } from 'webapp/utils/common';

interface Schedulable {
	scheduleDayOfWeek: DayOfTheWeek[];
	scheduleHourOfDay: number | null;
}

export class DeliveryTimeOption {
	value: DeliveryTimeType;
	label: string;
	// `tooltip` (not `tooltipText`) is what renders the info icon + tooltip on the radiobutton
	tooltip: string | undefined;
	tooltipIcon: IconName = 'InfoFill';
	scheduledDays: DayOfTheWeek[];
	scheduledHour: number;
	deliveryTimeRange: DeliveryTimeDateRangeType;

	constructor(
		value: DeliveryTimeType,
		label: string,
		tooltip: string | undefined,
		scheduledDays: DayOfTheWeek[],
		scheduledHour: number,
		deliveryTimeRange: DeliveryTimeDateRangeType,
	) {
		this.value = value;
		this.label = label;
		this.tooltip = tooltip;
		this.scheduledDays = scheduledDays;
		this.scheduledHour = scheduledHour;
		this.deliveryTimeRange = deliveryTimeRange;
	}

	isEqualSchedule(model: Schedulable, deliveryTimeRange: DeliveryTimeDateRangeType): boolean {
		return (
			equal(this.scheduledDays, model.scheduleDayOfWeek) &&
			model.scheduleHourOfDay === this.scheduledHour &&
			deliveryTimeRange === this.deliveryTimeRange
		);
	}
}
